import { Box, Typography } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import { InvitationEmailEditHintPosition } from './generateInvitationEmailTypes';

interface InvitationEmailEditHintBubbleProps {
  position: InvitationEmailEditHintPosition;
}

const InvitationEmailEditHintBubble: React.FC<InvitationEmailEditHintBubbleProps> = ({
  position,
}) => (
  <Box
    sx={{
      position: 'absolute',
      top: `${position.top}px`,
      left: `${position.left + 16}px`,
      transform: 'translateY(-50%)',
      backgroundColor: Palette.tone4.background,
      color: Palette.tone4.text,
      padding: '8px 12px',
      borderRadius: '8px',
      whiteSpace: 'nowrap',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      zIndex: 3,
      pointerEvents: 'none',
      animation: 'pop-out 0.8s cubic-bezier(0.68, -0.55, 0.27, 1.55) forwards',
      '@keyframes pop-out': {
        '0%': {
          opacity: 0,
          transform: 'translateY(-50%) scale(0.5)',
        },
        '70%': {
          opacity: 1,
          transform: 'translateY(-50%) scale(1.1)',
        },
        '100%': {
          transform: 'translateY(-50%) scale(1)',
        },
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        width: 0,
        height: 0,
        borderTop: '8px solid transparent',
        borderBottom: '8px solid transparent',
        borderRight: `8px solid ${Palette.tone4.background}`,
        left: '-8px',
        top: '50%',
        transform: 'translateY(-50%)',
      },
    }}
  >
    <Typography
      variant="body2"
      sx={{
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: 1.2,
      }}
    >
      Click to edit
    </Typography>
  </Box>
);

export default InvitationEmailEditHintBubble;
